<template>
    <div id="labels" :class="labelsClass">
        <ul ref="list" class="labels__list">
            <li v-for="(file, index) in files" :key="index" ref="file" class="labels__label">
                <span>{{ file.file.name }}</span>

                <button type="button" @click.stop="removeFile(file)">
                    <common-icon name="close" size="tiny"></common-icon>
                </button>
            </li>
        </ul>
        <div v-if="moreCount > 0 && !shouldShowAll" class="file-labels__more" @click="showAllFiles">
            {{ `+${moreCount}` }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            files: { type: Array, required: true },
        },

        data() {
            return {
                moreCount: 0,
                shouldShowAll: false,
            }
        },

        computed: {
            labelsClass() {
                return {
                    labels: true,
                    'labels--show-all': this.shouldShowAll,
                }
            },
        },

        methods: {
            recalculateMore() {
                this.$nextTick(() => {
                    const allFiles = this.$refs.file
                    const visibleFiles = []

                    if (!Array.isArray(allFiles)) {
                        return
                    }

                    for (const file of allFiles) {
                        if (file.offsetTop === 0) {
                            visibleFiles.push(file)
                        }
                    }

                    this.moreCount = allFiles.length - visibleFiles.length
                })
            },

            showAllFiles() {
                this.shouldShowAll = true
                this.emitEvent({ name: 'show-all-files' })
            },

            hideFiles() {
                this.shouldShowAll = false
            },

            removeFile(file) {
                this.emitEvent({ name: 'remove', payload: file })
                this.recalculateMore()
            },
        },

        watch: {
            files() {
                this.recalculateMore()
            },

            moreCount(newValue, oldValue) {
                if (newValue !== oldValue) {
                    // Trigger recalculation again in case when text of "+ X more"
                    // causes even more labels to hide.
                    this.recalculateMore()
                }
            },

            shouldShowAll() {
                if (!this.shouldShowAll) {
                    var el = document.getElementById('labels')
                    el.scrollTo(0, 0)
                }
            },
        },

        mounted() {
            this.recalculateMore()
        },
    }
</script>
